import { render, staticRenderFns } from "./EditAssetIssuance.vue?vue&type=template&id=0edf196e"
import script from "./EditAssetIssuance.vue?vue&type=script&lang=js"
export * from "./EditAssetIssuance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports